<script setup lang="ts">
import type { GyldendalMeaning } from "@/types/article-formats/gyldendal";

import ArticleEtymology from "./ArticleEtymology.vue";
import ArticleReferences from "./ArticleReferences.vue";
import ArticleRelations from "./ArticleRelations.vue";
import ArticleSubMeanings from "./ArticleSubMeanings.vue";

defineProps<{
  meanings: GyldendalMeaning[];
  articleId: number;
}>();

const getNumber = (index: number) => index + 1;

const getDescription = (meaning: GyldendalMeaning) => {
  const description = meaning.description ?? "";
  const productiveDescription = meaning.productiveDescription ?? "";

  return [description, productiveDescription].join(" ").trim();
};
</script>

<template>
  <div :class="{ 'indentation-container': meanings.length > 1 }">
    <div
      v-for="(meaning, meaningIndex) in meanings"
      :key="meaningIndex"
      class="article-content__block"
    >
      <span v-if="meanings.length > 1" class="article-list-bullet"
        >{{ getNumber(meaningIndex) }}.</span
      >

      <div
        v-if="getDescription(meaning)"
        class="article-content__description"
        v-html="getDescription(meaning)"
      ></div>

      <ArticleSubMeanings
        :sub-meanings="meaning.subMeanings"
        :article-id="articleId"
        :meaning-id="meaning.id"
      />

      <ArticleRelations
        v-if="meaning.relations.length > 0"
        :relations="meaning.relations"
      ></ArticleRelations>

      <ArticleReferences :references="meaning.references" />

      <ArticleEtymology v-if="meaning.etymology" :etymology="meaning.etymology"></ArticleEtymology>
    </div>
  </div>
</template>
